import { useLocation, useNavigate } from 'react-router-dom';

interface LocationState {
  from?: string;
  customerId?: string;
  tab?: string;
}

export interface BackNavigation {
  canGoBack: boolean;
  backLabel: string;
  goBack: () => void;
}

/**
 * Hook to manage backward navigation throughout PSA.
 * Allows users to return to where they came from (e.g., customer form on specific tab).
 */
export function useBackNavigation(): BackNavigation {
  const location = useLocation();
  const navigate = useNavigate();
  const state = (location.state as LocationState) || {};
  const search = new URLSearchParams(location.search);

  const returnCustomerId = state.customerId ?? search.get('returnCustomerId') ?? undefined;
  const returnTab = state.tab ?? search.get('returnTab') ?? 'details';
  const fromCustomer = state.from === 'customer' || search.has('returnCustomerId');

  const canGoBack = fromCustomer && Boolean(returnCustomerId);

  const goBack = (): void => {
    if (canGoBack && returnCustomerId) {
      // Navigate back to customers page with query params to restore the modal
      navigate(`/customers?returnCustomerId=${returnCustomerId}&returnTab=${returnTab}`);
    } else {
      navigate(-1);
    }
  };

  const backLabel = canGoBack ? 'Back to customer' : 'Back';

  return { canGoBack, backLabel, goBack };
}
